import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ChecklistEventService } from 'src/app/events/services/checklist-event.service';

// services
import { ReportService } from '../../services/report.service';
import { ReportFormatterService } from '../../services/report-formatter.service';
import { ReportTableService } from '../../services/report-table.service';
import { ReportExportService } from '../../services/report-export.service';
import { ConfirmationService } from 'primeng-lts/api';

// models
import { ReportPayload } from '../../models/report-payload';
import { ReportType } from '../../models/report-types';
import { ReportCategory } from '../../models/report-category';
import { ReportTableColumn } from '../../models/report-table';
import { reportFileNames } from '../../models/report-export';
interface ReportExportOption {
  code: string;
  permission: string;
  label?: string;
  action: () => void;
}

@Component({
  selector: 'app-report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss']
})
export class ReportViewerComponent implements OnInit {

  private reportSubscription!: Subscription;

  public reportOptionExcel: ReportExportOption[] = []
  public reportOptionPdf: ReportExportOption[] = []
  public reportOptionHtml: ReportExportOption[] = []

  // data  
  public reportPayload?: ReportPayload
  public reportCategory: ReportCategory = ReportCategory.DEPRECATED;
  public reportColumns: ReportTableColumn[] = []
  
  // utils
  public Categories = ReportCategory;
  public progressMessage : string = "";  
  // control
  public report_completed: boolean = false;
  public showReport: boolean = false;

  constructor(
    public reportService: ReportService,
    public reportTableService: ReportTableService,
    public reportFormatterService: ReportFormatterService,
    public exportableReport: ReportExportService,
    private spinner: NgxSpinnerService,
    private confirmationService:ConfirmationService,
    private checklist : ChecklistEventService
  ) {
    this.checklist.progressMessage$.subscribe((message)=>{
      this.progressMessage = message;
    })
  }

  // events
  ngOnInit(): void {
    const isIndependentWindow = !document.getElementById('vehicle_label');
    if (isIndependentWindow) {
      this.loadReportFromStorage();
    } else {
      this.loadReportFromService();
    }
  }
  ngOnDestroy(): void {
    if (this.reportSubscription) {
      this.reportSubscription.unsubscribe();
    }
  }


  // obtener el Reporte
  private loadReportFromService(): void {
    this.reportSubscription = this.reportService.reportGenerated
      .subscribe({
        next: (data: ReportPayload) => {
          this.processReportData(data);
        },
        error: (err: string) => {
          console.error('Error getting report data from service:', err);
        }
      });
  }
  private loadReportFromStorage(): void {
    const storedData = localStorage.getItem('report_payload');

    if (!storedData) {
      console.warn('No report data found in localStorage');
      return;
    }

    try {
      const reportData: ReportPayload = JSON.parse(storedData);
      localStorage.removeItem('report_data');
      this.processReportData(reportData);
    } catch (error) {
      console.error('Error parsing report data from localStorage:', error);
    }
  }

  // core
  private processReportData(reportData: ReportPayload): void {
    this.resetResult();
    this.reportPayload = reportData;

    // asegurar que el tipo de reporte es valido
    const inputType = reportData.reportDetails.reportType;
    // Validar tipo de reporte
    const reportType = Object.values(ReportType).includes(inputType) ? inputType : ReportType.UNDEFINED;

    // Asignar detalles de manera clara
    const baseName = reportFileNames[reportType] ?? "reporteDefault";
    const periodRange = this.reportPayload.reportDetails?.periodRange || "";

    // Reemplazar caracteres inválidos para nombres de archivo
    const safePeriod = periodRange.replace(/[\/\\:*?"<>|]/g, "-");

    const nameFile = `${baseName}${safePeriod ? "_" + safePeriod : ""}`;
    const reportDetails = {
      ...reportData.reportDetails,
      reportType,
      category: this.reportService.getReportCategory(reportType),
      nameFile
    };

    // Asignar al payload
    this.reportPayload.reportDetails = reportDetails;

    // Guardar categoría para uso local
    this.reportCategory = reportDetails.category;

    if(this.reportCategory === ReportCategory.DEPRECATED) {
      console.error('ReportViewerComponent: Invalid or undefined report category.');
      this.spinner.hide("reportSpinner");
      this.reportService.workingOnReport = false; // habilitar el formulario de reporte
      this.report_completed = false;
      this.showReport = true; // mostrar mensaje de error
      return;
    }
    // obtener los permisos de exportacion
    this.exportableReport.applyExportPermissions(this.reportPayload);

    // obtener las columnas de la tabla
    this.reportPayload.columns = this.reportTableService.getColumns(
      reportData.reportDetails.reportType, this.reportPayload
    );
    this.reportColumns = this.reportPayload.columns || [];

    this.reportPayload.dataViewer = this.reportFormatterService.getReporDatatFormat(reportData);

    // complete
    console.log('report-viewer : Report Payload:', this.reportPayload);
    console.log('report-viewer : Report Columns:', this.reportColumns);

    this.spinner.hide("reportSpinner");
    this.reportService.workingOnReport = false; // habilitar el formulario de reporte
    this.report_completed = true;
    this.showReport = true;
    this.reportService.reportFinished.emit(true);
  }

  // controls
  public exportReport(format : string) {
    if(this.reportPayload){
      if(this.reportCategory == ReportCategory.VEHICLE
        || this.reportCategory == ReportCategory.EVENT
      ){
        if(!this.reportPayload.filters.includeOnlyTable){
          if(format == 'excel'){
            this.confirmationService.confirm({
              key: 'showSelectExcelConfirmation', reject: () => {}, accept: () => {}
            });
            return;
          } else {
            this.exportableReport.exportVehicleReport(this.reportPayload, format)
            return;
          }
        }
      }
      this.exportableReport.exportReport(this.reportPayload, format);
    }
  }
  public configReporteUnido() {
    if(this.reportPayload){
      this.exportableReport.exportVehicleReportDataToExcel(this.reportPayload, this.reportPayload.dataViewer)
    }
  }
  public configReporteSeparado() {
    if(this.reportPayload){
      this.exportableReport.exportVehicleReportDataToExcel(this.reportPayload, this.reportPayload.dataViewer, false)
    }
  }

  // util
  private resetResult() {
    this.reportPayload = undefined
    this.showReport = false;
  }
}
